import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { WinGameFixture } from '@frontend/sports/racing/feature/models';
import { Observable, map } from 'rxjs';

import { GreyhoundRacingApiService } from '../../../../horse-racing-shared/services/greyhound-racing-api.service';

export interface GreyhoundNextRaceModel {
    fixtures: WinGameFixture[];
}
@Injectable()
export class GreyhoundHomeResolver {
    constructor(private apiService: GreyhoundRacingApiService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<GreyhoundNextRaceModel> {
        return this.apiService.getNextFixtures().pipe(
            map((fixtures) => {
                return {
                    fixtures,
                };
            }),
        );
    }
}
